import { IconProps } from ".";
import Icon from "./assets/grid_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Grid(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
